import { Component, Inject } from '@angular/core'
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar'

@Component({
  selector: 'lin-snack-bar',
  template: `
    <span>{{ message }}</span>
    <mat-icon class="toggle" svgIcon="close" (click)="close()"></mat-icon>
  `,
  styleUrls: ['./snack-bar.component.scss'],
  standalone: false,
})
export class SnackBarComponent {
  constructor(
    private readonly snackBarRef: MatSnackBarRef<SnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) readonly message: string,
  ) {}

  close(): void {
    this.snackBarRef.dismiss()
  }
}
